"use client"
import { IconButton } from "@/components/ui/IconButton"
import { Tooltip } from "@/components/ui/Tooltip"
import { Tour, TourArrow, TourContent, TourFooter, TourOverlay, TourStep } from "@/components/ui/tour"
import { useLocalStorage } from "@/lib/hooks/useLocalStorage"
import { TOUR } from "@/lib/static/tour-config"
import { Info } from "lucide-react"
import { usePathname, useRouter, useSearchParams } from "next/navigation"
import { useEffect, useState } from "react"

const tourPages = [
  {
    path: /^\/$/,
    tour: TOUR.HOME,
  },
  {
    path: /^\/innovations$/,
    tour: TOUR.INNOVATIONS,
  },
  {
    path: /^\/profile\/interests$/,
    tour: TOUR.INTERESTS,
  },
  {
    path: /^\/megatrends$/,
    tour: TOUR.MEGATRENDS,
  },
  {
    path: /^\/macrotrends$/,
    tour: TOUR.MACROTRENDS,
  },
  {
    path: /^\/subtrends$/,
    tour: TOUR.SUBTRENDS,
  },
  {
    path: /^\/library\/projects$/,
    tour: TOUR.PROJECTS,
  },
  {
    path: /^\/library\/projects\/[a-zA-Z0-9-_]+$/,
    tour: TOUR.PROJECT,
  },
]

export function NavTour() {
  const pathname = usePathname()
  const router = useRouter()

  const activeTour = pathname && tourPages.find((page) => page.path.test(pathname))

  if (!activeTour) return null

  return (
    <>
      <Tooltip label="Take a tour on this page">
        <IconButton
          className="tour-home-tour hidden size-9 lg:block"
          onClick={() => router.push(`${pathname}?tour=true`)}
          icon={<Info size={16} />}
          aria-label="Tour"
          variant="outline"
        />
      </Tooltip>
      <TourPopups activeTour={activeTour} />
    </>
  )
}

function TourPopups({ activeTour }: { activeTour: (typeof tourPages)[number] }) {
  const pathname = usePathname()
  const searchParams = useSearchParams()
  const [welcomeTourIsOpen, setWelcomeTourIsOpen] = useLocalStorage("tw:welcome:modal", true)

  const isTourActive = searchParams?.has("tour")
  const [isTourUrlOpen, setIsTourUrlOpen] = useState(false)
  useEffect(() => {
    if (isTourActive) {
      setIsTourUrlOpen(true)
    }
  }, [isTourActive])
  const router = useRouter()
  const shouldShowTour = activeTour && isTourActive && (isTourUrlOpen || welcomeTourIsOpen)
  if (!shouldShowTour) return null

  return (
    <Tour
      steps={activeTour.tour}
      isOpen={shouldShowTour}
      onClose={() => {
        router.push("?")
        setIsTourUrlOpen(false)
        if (pathname === "/") setWelcomeTourIsOpen(false)
      }}
    >
      <TourOverlay />
      <TourContent>
        <TourArrow />
        <TourStep />
        <TourFooter />
      </TourContent>
    </Tour>
  )
}
